var _circle, _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg2 = function Svg2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "url(#paint0_linear_692_423039)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64516 29H15.4037C16.6025 28.9083 19 28.01 19 25.15C19 23.225 17.0312 21.85 15.625 21.85C15.625 21.025 14.5 18 11.125 18C8.875 18 7.75 19.375 7.0877 20.2C6.50706 19.925 4.9375 19.925 4.09375 20.2C3.25 20.475 1 21.85 1 24.6C1 27.35 3.53125 29 5.64516 29Z",
    fill: "url(#paint1_linear_692_423039)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9032 12H21.3975C20.5983 11.9333 19 11.28 19 9.2C19 7.8 20.3125 6.8 21.25 6.8C21.25 6.2 22 4 24.25 4C25.75 4 26.5 5 26.9415 5.6C27.3286 5.4 28.375 5.4 28.9375 5.6C29.5 5.8 31 6.8 31 8.8C31 10.8 29.3125 12 27.9032 12Z",
    fill: "url(#paint2_linear_692_423039)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_423039",
    x1: 5.5,
    y1: 4.625,
    x2: 27.1562,
    y2: 26.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB41C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_692_423039",
    x1: 6,
    y1: 19,
    x2: 16.2291,
    y2: 28.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_692_423039",
    x1: 21.1062,
    y1: 4.66969,
    x2: 28.9999,
    y2: 12.0774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2.d1c889b4.svg";
export { ForwardRef as ReactComponent };